module.exports = __webpack_public_path__ + "static/media/Caret.ce26916d.svg";